import type {
  APIComponentAttributes,
  LoadedGraphChunk,
  TraversalLoadedStateParams,
} from '@ardoq/api-types';
import { anyType } from '@ardoq/global-consts';
import { pathOperations } from 'traversals/pathOperations';
import { getDefaultWildcardViewpoint } from 'traverseOneLevel/defaultWildcardViewpoint';

// If all components in the start set are of the same type, and we're using a
// wildcard start node, we convert it to use the relevant type name instead
export const maybeConvertWildcardStartType = (
  params: TraversalLoadedStateParams,
  result: LoadedGraphChunk
): TraversalLoadedStateParams => {
  // A hierarchy expansion starts from the wildcard sentinel by design, and its
  // paths are the traversal the user authored - not a default wildcard viewpoint
  // to be re-anchored.
  if (params.data.startSetExpansion) return params;

  const traversalStartType = pathOperations.getStartTypeFromPaths(
    params.data.paths
  );
  if (traversalStartType !== anyType) return params;

  const { startSetResult } = result.componentIdsAndReferences;
  if (startSetResult.length === 0) {
    return params;
  }

  const startSet = new Set(startSetResult);
  const isInStartSet = ({ _id }: APIComponentAttributes) => startSet.has(_id);
  const toType = ({ type }: APIComponentAttributes) => type;
  const startTypes = new Set(
    result.scopeData.components.filter(isInStartSet).map(toType)
  );

  if (startTypes.size !== 1) {
    return params;
  }

  const [startType] = startTypes;
  return {
    ...params,
    data: {
      ...params.data,
      paths: getDefaultWildcardViewpoint(startType),
    },
  };
};
